import React from 'react';
import Form from '../../../components/molecules/Form/Form';
import { FormContainerModifier } from '../../../components/molecules/Form';
import TopHeadlinesFormTemplate from './TopHeadlinesFormTemplate';
import { TopHeadlineImage, TopHeadlineImageSmall } from '../../../types/api/ImageType';
import IForm from '../../../types/IForm';

export type FormType = 'create' | 'update';

type TopHeadlinesForm = {
  form: IForm;
  type: FormType;
  image?: TopHeadlineImage | TopHeadlineImageSmall;
};

export function TopHeadlinesForm({ form, type, image }: TopHeadlinesForm) {
  const id = type === 'create' ? 'top-headline-create-form' : 'top-headline-update-form';

  return (
    <Form id={id} model={form} containerModifier={FormContainerModifier.NO_PADDING}>
      <TopHeadlinesFormTemplate type={type} image={image} />
    </Form>
  );
}
